import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { Row, Col } from "react-bootstrap"
import ScrollAnimation from "react-animate-on-scroll"
import CallToActionImg from "../../images/call-to-action.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"
import ConvenientBookingPageStyle from "./convenient-booking-page.module.scss"

const CallToAction = () => (
    <StaticQuery query={graphql`
        query BookingCTA{
            contentfulConvenientBookingPage{
                convenientBookingReference{
                 sectionContent3{
                    subtitle{
                    subtitle
                    }
                    sectionParagraph{
                        json
                        }
                    }
                }
            }
        }
    `}
    render={data => (
    <div className={ConvenientBookingPageStyle.sectionDiv}>
        <Row>
            <Col className={ConvenientBookingPageStyle.ctaCol1} xs={12}>
                <h3 className={ConvenientBookingPageStyle.sectionTitle}>{data.contentfulConvenientBookingPage.convenientBookingReference.sectionContent3.subtitle.subtitle}</h3>
                <div className={ConvenientBookingPageStyle.sectionDescription}>
                    {documentToReactComponents(data.contentfulConvenientBookingPage.convenientBookingReference.sectionContent3.sectionParagraph.json)}
                </div>
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true}>
                    <CallToActionImg className={ConvenientBookingPageStyle.callToActionImg} />
                </ScrollAnimation>
            </Col>
        </Row>
        <Row className={ConvenientBookingPageStyle.convenientBookingLinksRow1}>
            <Col className={ConvenientBookingPageStyle.convenientBookingLinksCol} md={12}>
                <Link to="/essentials" className={ConvenientBookingPageStyle.convenientBookingLinks}>The Essentials</Link>
                <Link to="/mobile-first" className={ConvenientBookingPageStyle.convenientBookingLinks}>Mobile First</Link>
                <Link to="/engaging-menu" className={ConvenientBookingPageStyle.convenientBookingLinks}>Engaging Menu</Link>
                <span className={ConvenientBookingPageStyle.activeLink}>Convenient Booking</span>
            </Col>
        </Row>
        <Row className={ConvenientBookingPageStyle.convenientBookingLinksRow2}>
            <Col className={ConvenientBookingPageStyle.convenientBookingLinksMobileCol} xs={12}>
                <Link to="/engaging-menu" className={ConvenientBookingPageStyle.convenientBookingLinksMobile}><FontAwesomeIcon icon={faArrowLeft} className={ConvenientBookingPageStyle.chevronIcons} /> Previous</Link>
            </Col>
        </Row>
    </div>
    )}
    />
)

export default CallToAction